import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useEffect } from 'react';


const CheckBtnBlock = styled.div`
    display: block;
    margin: ${props => props.margin || '0px 0px'};
`;

const ChecBtnInputBlock = styled.input`
    display: inline-block;
    cursor: pointer;
    right: 5px;
    width: 26px;
    height: 26px;
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    background-color: #e0e0e0;
    border-radius: 50%;
    background-size: cover;
    outline: 0;
    outline: none;
    border: none;
    &:focus {
        //border: 0px solid #ffc742;
        outline: 0
    }

`;

const CheckBtn = ({ onClick, margin, defaultValue, disable=false }) => {

    const [checked, setChecked] = useState(defaultValue);


    useEffect(() => {
        //console.log("check = " + defaultValue)
        setChecked(defaultValue);
    }, [defaultValue]);

    const handleClick = () => {
        if(onClick !== null && onClick !== undefined) {
            onClick(!checked);
            setChecked(!checked);
        }
    }

    return (
        <CheckBtnBlock margin={margin}>
            <ChecBtnInputBlock
                type="checkbox"
                img={disable? '': checked ? "/assets/images/icon/cc-icon-checked.png" : "/assets/images/icon/cc-icon.png"}
                onClick={handleClick} />
        </CheckBtnBlock>

    );
};

export default CheckBtn;